import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { AppService } from '../../../app.service';

@Injectable({
    providedIn: 'root',
})
export class UsersService {
    private _data: BehaviorSubject<any> = new BehaviorSubject(null);

    /**
     * Constructor
     */
    constructor(
        private _httpClient: HttpClient,
        private appService: AppService
    ) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for data
     */
    get data$(): Observable<any> {
        return this._data.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    saveUser(data: any) {
        return this._httpClient.post(
            this.appService.getApiUrl() + 'user/add-user/',
            data
        );
    }
    getUserById(_id: any) {
        return this._httpClient.get(
            this.appService.getApiUrl() + 'user/get_by_id/' + _id
        );
    }
    /**
     * Get Users
     */
    getUsers(status: any) {
        return this._httpClient.post(
            this.appService.getApiUrl() + 'user/get_by_status',
            status
        );
    }

    /**
     * Get Designations
     */
    getDesignations() {
        return this._httpClient.get(
            this.appService.getApiUrl() + 'designation/list'
        );
    }

    /**
     * Get User Types
     */
    getUserTypes() {
        return this._httpClient.get(
            this.appService.getApiUrl() + 'userType/list'
        );
    }

    /**
     * Update User Data
     */
    updateUserInfoOnly(userID, data: any) {
        return this._httpClient.put(
            this.appService.getApiUrl() + 'user/update-info/' + userID,
            data
        );
    }

    updateUser(userID, data: any) {
        return this._httpClient.put(
            this.appService.getApiUrl() + 'user/update/' + userID,
            data
        );
    }

    /**
     * Approve User
     */
    approveUser(userId) {
        return this._httpClient.put(
            this.appService.getApiUrl() + 'user/approve',
            { userId }
        );
    }

    /**
     * Archive User
     */
    archiveUser(userId) {
        return this._httpClient.get(
            this.appService.getApiUrl() + 'user/archive/' + userId
        );
    }

    /**
     * Restore User
     */
    restoreUser(userId) {
        return this._httpClient.get(
            this.appService.getApiUrl() + 'user/unarchive/' + userId
        );
    }

    /**
     * Delete User
     */
    deleteUser(userId) {
        return this._httpClient.delete(
            this.appService.getApiUrl() + 'user/delete/' + userId
        );
    }

    /**
     * Fetch User Designations
     */
    getUserDesignations() {
        return this._httpClient.get(
            this.appService.getApiUrl() + 'user/designations'
        );
    }
    userSecuritySetting(data) {
        return this._httpClient.post(
            this.appService.getApiUrl() + 'user/user-security-settings',
            data
        );
    }
    changePasswordSettings(data) {
        return this._httpClient.post(
            this.appService.getApiUrl() + 'user/update-user-credentials',
            data
        );
    }
    downloadData() {
        return this._httpClient.get(
            this.appService.getApiUrl() + 'user/downloadData',{ responseType: 'blob' }
        );
    }
}
